export default __webpack_public_path__ + "static/media/logo_bee_new.27013ece.svg";